import { AlertCircle } from "lucide-react";

import { HeaderText } from "@src/shared/components/general/HeaderText";
import { Logo } from "@src/shared/components/general/Logo";
import { Text } from "@src/shared/components/general/Text";
import { VerticalFlexbox } from "@src/shared/components/layout/Flexbox";
import { Button } from "@src/shared/components/ui/button";
import { Spinner } from "@src/shared/components/ui/spinner";

export interface IframeLoginPageV2Props {
  isLoading?: boolean;
  error?: string | null;
  onRetry?: () => void;
}

export function IframeLoginPageV2({
  isLoading,
  error,
  onRetry,
}: IframeLoginPageV2Props) {
  return (
    <VerticalFlexbox
      as="main"
      alignItems="center"
      justifyContent="center"
      className="min-h-full w-full bg-background px-6 py-10 text-foreground"
    >
      <VerticalFlexbox
        alignItems="center"
        className="w-full max-w-[360px] text-center"
      >
        <Logo variant="lockup" className="h-[54px]" />

        <HeaderText
          tag="h1"
          className="mt-[18px] text-balance text-[24px] leading-tight tracking-[-0.6px]"
        >
          Connecting to your chart
        </HeaderText>

        {isLoading ? (
          <VerticalFlexbox alignItems="center" className="mt-6" gap="md">
            <Spinner size="lg" />
            <Text appearance="subdued" sizing="sm">
              Signing you in from Elation...
            </Text>
          </VerticalFlexbox>
        ) : null}

        {error && !isLoading ? (
          <VerticalFlexbox
            alignItems="center"
            className="mt-6 w-full rounded-xl border border-destructive/40 bg-destructive/10 px-4 py-4"
            gap="sm"
            role="alert"
          >
            <AlertCircle
              className="size-5 text-destructive"
              strokeWidth={2}
              aria-hidden="true"
            />
            <Text className="font-semibold" sizing="sm">
              Something went wrong
            </Text>
            <Text appearance="subdued" sizing="sm">
              {error}
            </Text>
            {onRetry ? (
              <Button
                className="mt-2 h-9 rounded-[9px] px-4 text-[13.5px] font-semibold"
                onClick={onRetry}
                type="button"
                variant="outline"
              >
                Refresh
              </Button>
            ) : null}
          </VerticalFlexbox>
        ) : null}
      </VerticalFlexbox>
    </VerticalFlexbox>
  );
}
